export function resolver(object, path, def) {
  return path.split(".").reduce(function (a, b) {
    return (a && a[b]) || def;
  }, object);
}